import { render, staticRenderFns } from "./a-header.vue?vue&type=template&id=35c8bade&scoped=true"
import script from "./a-header.vue?vue&type=script&lang=js"
export * from "./a-header.vue?vue&type=script&lang=js"
import style0 from "./a-header.vue?vue&type=style&index=0&id=35c8bade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8bade",
  null
  
)

export default component.exports